import nl2br from "./nl2br";

declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/partners.scss';

import { h, Component } from 'preact';
import {Link} from "preact-router/match";

const partners = [
  {
    name: 'IBM',
    skills: ['technology', 'sales'],
    logo: 'brands/IBM.png',
    web: 'https://www.ibm.com',
    contacts: [{
      name: '',
      mail: '',
      phone: null
    }]
  },
  {
    name: 'Forbes Insights',
    skills: ['marketing', 'sales'],
    logo: 'brands/ForbesInsights.png',
    web: 'https://www.forbes.com/forbes-insights/',
    contacts: [{
      name: 'Brian McLeod',
      mail: 'BMcLeod@forbes.com',
      phone: null
    }]
  },
  {
    name: 'Microsoft',
    skills: ['technology', 'sales'],
    logo: 'brands/Microsoft.png',
    web: 'https://azure.microsoft.com',
    contacts: [{
      name: '',
      mail: '',
      phone: null
    }]
  },
  {
    name: 'Growth Drivers',
    skills: ['marketing', 'design', 'sales'],
    logo: 'partners/growth-drivers.png',
    web: 'https://www.gr0wthdr1vers.com',
    contacts: [{
      name: 'Steve McDermott',
      mail: 'steve@gr0wthdr1vers.com',
      phone: null
    },{
      name: 'Eric Berman',
      mail: 'eric@gr0wthdr1vers.com',
      phone: null
    }]
  },
  {
    name: 'Sunrise Evolution',
    skills: ['implementation', 'sales'],
    logo: 'partners/Sunrise-Evolution-Technologies.png',
    web: 'https://www.sun-evo.com',
    contacts: [{
      name: 'Magda Jamal',
      mail: 'mjamal@sun-evo.com',
      phone: null
    }]
  },
  {
    name: '10xDS',
    skills: ['implementation', 'sales'],
    logo: 'partners/10ds.png',
    web: 'https://www.10xds.com/',
    contacts: [{
      name: 'Binu Koshy',
      mail: 'Binu.Koshy@10xds.com',
      phone: null
    }]
  },
  {
    name: 'S.T.I.',
    skills: ['implementation', 'sales'],
    logo: 'partners/sti.jpg',
    web: 'https://wwww.stideponte.com',
    contacts: [{
      name: 'Gabriella de Ponte',
      mail: 'gabriella@deponte-sti.com',
      phone: null
    }]
  },
  {
    name: 'Tegsoft',
    skills: ['technology', 'sales'],
    logo: 'partners/tegsoft.png',
    web: 'https://www.tegsoft.com',
    contacts: [{
      name: 'Eray Gürsoy',
      mail: 'eray.gursoy@tegsoft.com',
      phone: null
    }]
  },
  {
    name: 'Renew HR',
    skills: ['implementation', 'sales'],
    logo: 'partners/renew-hr.png',
    web: 'https://www.renewhr.com',
    contacts: [{
      name: 'Sabya Mitra',
      mail: 'sabya.mitra@renewhr.com',
      phone: null
    }]
  },
  {
    name: 'Speakap',
    skills: ['technology', 'sales'],
    logo: 'partners/speakap.svg',
    web: 'https://www.speakap.com',
    contacts: [{
      name: 'Erwin van der Vlist',
      mail: 'erwin.vlist@speakap.com',
      phone: null
    }]
  }
];

const icons = {
  technology: 'microchip',
  implementation: 'code-branch',
  sales: 'store',
  design: 'swatchbook',
  marketing: 'chart-line'
};

export default class Partners extends Component<any, any> {

    constructor() {
        super();
        this.setState({filter: 'all'})
      this.partners = partners.sort((a, b) => a.name.localeCompare(b.name));
    }

    public render (props, state): any {
  
      const list = this.partners.map( p => p.skills.indexOf(state.filter) != -1 || state.filter === 'all' ? <li>
                  <div class="descr">
                    <div class="logoWrp">
                      <img src={ STATIC_BASE_URL + 'images/public/' + p.logo } alt={p.name} />
                    </div>
                    <div class="contacts">
                      { p.contacts.map( c => c.name ? <div>
                          <p><i class="fa fa-user"></i> <b>{ c.name }</b></p> { c.mail ? <p><i class="fa fa-envelope"></i> <a href={ 'mailto:' + c.mail }>{ c.mail }</a></p> : '' }
                        </div> : '')}
                      <div>
                        <p><i class="fa fa-home"></i> <a href={ p.web } target="_blank">{ p.web }</a></p>
                      </div>
                      
                    </div>
                    <ul class="skills">
                      { p.skills.map( s => <li>
                        <div class="icon"><div><i class={'fa fa-' + icons[s]}></i></div></div> { s }
                      </li>)}
                    </ul>
                  </div>
                </li> : '');

        return <div id="partners">
          {/*<section class="full grey">
              <h2>What our Partners think</h2>
              <ul>
                <li>
                  <blockquote>
                    Get a Quote or statement from Brian (Forbes) to boost the message here​
                    <span>Partner x</span>
                  </blockquote>
                </li>
              </ul>
              <p class="center"><a href={ STATIC_BASE_URL + 'contacts' } class="butt huge">Become a Partner</a></p>
          </section>*/}
          
          
          <div class="mainWrp">
            <section class="partners">
              <h2>Our Partners</h2>
              
              <ul class="filters">
                { Object.keys(icons).map((val) => <li>
                  <div class={ 'icon ' + (val === state.filter ? 'sel' : '') } onClick={ e => this.setState({filter: state.filter === val ? 'all' : val}) }><div><i class={'fa fa-' + icons[val] }></i></div></div>
                </li>) }
              </ul>
              
              <ul class="cols">
                { list }
              </ul>
            </section>
          </div>
          
        </div>
    }
}


// WEBPACK FOOTER //
// ./ts/Partners.tsx